import { BaseApiClient } from './base-client';
import { 
  CreatePaymentSessionRequest, 
  PaymentSessionResponse,
  VerifyPaymentSessionResponse
} from '../types/payments';

export class PaymentsApiClient extends BaseApiClient {
  /**
   * Create a payment session for secure payment handling
   */
  async createSession(request: CreatePaymentSessionRequest): Promise<PaymentSessionResponse> {
    return this.post<PaymentSessionResponse>('/api/v1/payments/session', request);
  }

  /**
   * Verify a payment session status
   */
  async verifySession(sessionToken: string): Promise<VerifyPaymentSessionResponse> {
    return this.get<VerifyPaymentSessionResponse>(`/api/v1/payments/session/${sessionToken}/verify`);
  }

  /**
   * Get payment status by session token
   */
  async getPaymentStatus(sessionToken: string): Promise<VerifyPaymentSessionResponse> {
    return this.get<VerifyPaymentSessionResponse>(`/api/v1/payments/session/${sessionToken}/status`);
  }
}
